import React, { useState, useEffect } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import NewForm from './NewForm'

export default function User() {

  const [createNewFlag, setCreateNewFlag] = useState(false)
  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('')

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role === 'SuperAdmin') {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['User_Access Specifier']);
    }

  }, []);


  return (
    <>
      <div className="container mt-1">
        <div className="p-5 bg-light rounded shadow-sm">
          <div className="row">

            <div className="row my-1 ">
              <div className="col-md-6">
                <Typography className="mx-3" variant='h4' sx={{ pb: 1 }}>
                  User / {accessType === 'View' ? "View Only Mode" : createNewFlag ? ('Add') : ('Edit')}
                </Typography>
              </div>
              <div className="col-md-6 d-flex justify-content-end" >


              </div>
            </div>

            <div className="row">
              <div className="col-8 justify-content-end px-4">
                {accessType === 'View' ? "" : createNewFlag ? (
                  <Button variant="contained" onClick={() => setCreateNewFlag(false)} >Edit User</Button>
                ) : (
                  <Button variant="contained" onClick={() => setCreateNewFlag(true)} >+ New User</Button>
                )

                }
              </div>
            </div>
            {/* <div className="col-4 d-flex justify-content-end px-5">
        
         
        </div> */}

          </div>

          {accessType === 'View' ? <UpdateForm accessType={accessType} /> : createNewFlag ? (<NewForm />) : <UpdateForm />}
        </div>
      </div>
    </>
  );
}
